import styled from 'styled-components';

const StyledPageContainer = styled.div`
  box-sizing: border-box;
  height: 100vh;
  overflow: hidden;
  padding: 12px 16px;
`;
export { StyledPageContainer };
